import logoOnly from "./logoOnly.svg";
import logoOnlyInverse from "./logoOnlyInverse.svg";
import logo from "./logo-yo.svg";
import logoSmartPlan from "./LogoSmartPlan.svg";
export default { logoOnly, logoOnlyInverse, logo, logoSmartPlan };
